<script>
import isMobileDevice from '@utils/helpers/is-mobile'

export default {
  name: 'DialogShipConfirm',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      isMobile: isMobileDevice(),
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    submit() {
      this.loading = true
      this.$emit('on-created')
    },
    close() {
      this.$emit('close-clicked')
    },
    cancel() {
      // this.$emit('cancel')
      this.$emit('close-clicked')
    },
  },
}
</script>
<template>
  <v-dialog
    v-model="dialogShow"
    :content-class="$style.relativePosition"
    persistent
    max-width="355px"
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__ship_device') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <div style="font-weight: bolder; margin-bottom: 8px">{{
        $t('message__plugs_are_not_initialized') }}
          <div>
            {{ item && item.serial }}
          </div>
        </div>
        <div :class="$style.finalizeAlign">{{ $t('message__confirm_finalization') }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          :loading="loading"
          color="warning"
          @click="submit()">{{ $t('buttons__yes') }}</v-btn>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="close()">{{ $t('buttons__no') }}</v-btn>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="cancel()">{{ $t('buttons__cancel') }}</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" module>
@import '@design';

.finalizeAlign {
  max-width: fit-content;
  text-align: left !important;
  white-space: pre-line;
}
</style>
